<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-2']">
				{{ $t('titles.certificate') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						:disabled="true"
						v-model="certNumber"
						:label="$t('fields.certificateNumber')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<Upload :label="'* ' + $t('fields.file')" v-model="file"></Upload>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import Upload from '../../trinkets/Upload';
import InputField from '../../trinkets/InputField';

export default {
	name: 'ExternalCertificate',
	components: { Upload, InputField },
	props: {
		certificateId: [String, Number],
		certificateNumber: String,
		inEditMode: Boolean,
	},
	emits: ['close', 'reloadIssuedCertificates'],
	data() {
		return {
			file: {
				name: '',
				link: '',
				original_name: '',
				upload_id: null,
			},
			certNumber: this.certificateNumber,
		};
	},
	watch: {
		inEditMode(newVal) {
			if (newVal) {
				this.getFile();
			}
		},
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getFile() {
			let vm = this;
			if (this.certificateId) {
				this.$APICall('get', 'issued-certificates/file/' + this.certificateId, {}, (data, success) => {
					if (success) {
						this.file = data.certificate_file;
						this.certNumber = data.certificate_number;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (!this.file.upload_id) {
				success = false;
				errorMessages += this.$t('alerts.fileMissing') + '<br />';
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success && this.certificateId) {
				let vm = this;
				this.$APICall(
					'post',
					'issued-certificates/upload/' + this.certificateId,
					{ file: this.file },
					(data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.fileAdd'));
							vm.$modalBus.$emit('reloadIssuedCertificates');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						this.$emit('close');
					}
				);
			}
		},
	},
	mounted() {
		if (this.inEditMode) {
			this.getFile();
		}
	},
};
</script>
